// extracted by mini-css-extract-plugin
module.exports = {"andSeparator":"AndSeparator_andSeparator__20Z5q"};